import handleChatGreeting from '../../chatActions/handleChatGreeting';

export default function (_, { channel }) {
  if (channel === 'form') return { goToNextStep: true };

  return handleChatGreeting();
}
